import apiClient from "../../service/apiClient";
import qs from "qs";
import { GetFiltersRequest } from "pages/admin-app/shared/models/request/get-filters-request";
import { GetFiltersResponse } from "pages/admin-app/shared/models/response/get-filters-response";
import { CreateTerritoryManagerRequest } from "../models/request/create-territory-manager-request";
import { GetTerritoryManagerRequest } from "../models/request/get-territory-manager-request";
import { EditTerritoryManagerRequest } from "../models/request/edit-territory-manager-request";
import { EditTerritoryManagerResponse } from "../models/response/edit-territory-manager-response";
import { DeleteTerritoryManagerRequest } from "../models/request/delete-territory-manager-request";
import { DeleteTerritoryManagerResponse } from "../models/response/delete-territory-manager-response";
import { CreateTerritoryManagerResponse } from "../models/response/create-territory-manager-response";
import { GetTerritoryManagersRequest } from "../models/request/get-territory-managers-request";
import { GetTerritoryManagersResponse } from "../models/response/get-territory-managers-response";
import { GetTerritoryManagerResponse } from "../models/response/get-territory-manager-response";
import { GetSortAndFilterRequest } from "pages/admin-app/shared/models/request/get-sort-filters-request";

export async function getPaginatedTerritoryManagers(
  request: GetTerritoryManagersRequest
): Promise<GetTerritoryManagersResponse> {
  const response = await apiClient.get<GetTerritoryManagersResponse>(
    "/territory-manager",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
      },
    }
  );
  return response.data;
}

export async function getPaginatedByNameTerritoryManagers(
  request: GetTerritoryManagersRequest
): Promise<GetTerritoryManagersResponse> {
  const response = await apiClient.get<GetTerritoryManagersResponse>(
    "/territory-manager/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );
  return response.data;
}

export async function getTerritoryManagers(
  request: GetSortAndFilterRequest
): Promise<GetTerritoryManagersResponse> {
  const response = await apiClient.get<GetTerritoryManagersResponse>(
    "/territory-manager/search",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        sortBy: request.sortBy,
        orderBy: request.orderBy,
        filters: request.filters,
        searchQuery: request.searchQuery,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: true, arrayFormat: "brackets" }),
    }
  );
  return response.data;
}

export async function getTerritoryManager(
  request: GetTerritoryManagerRequest
): Promise<GetTerritoryManagerResponse> {
  const response = await apiClient.get<GetTerritoryManagerResponse>(
    `/territory-manager/${request.territoryManagerId}`
  );
  return response.data;
}

export async function updateTerritoryManager({
  territoryManagerId,
  ...territoryManagerData
}: EditTerritoryManagerRequest): Promise<EditTerritoryManagerResponse> {
  const response = await apiClient.patch<EditTerritoryManagerResponse>(
    `/territory-manager/${territoryManagerId}`,
    territoryManagerData
  );
  return response.data;
}

export async function deleteTerritoryManager(
  request: DeleteTerritoryManagerRequest
): Promise<DeleteTerritoryManagerResponse> {
  const response = await apiClient.delete<DeleteTerritoryManagerResponse>(
    `/territory-manager/${request.territoryManagerId}`
  );

  return response.data;
}

export async function createTerritoryManager(
  territoryManagerData: CreateTerritoryManagerRequest
): Promise<CreateTerritoryManagerResponse> {
  const response = await apiClient.post<CreateTerritoryManagerResponse>(
    "/territory-manager",
    territoryManagerData
  );
  return response.data;
}

export async function getTerritoryManagerFilters(
  request: GetFiltersRequest
): Promise<GetFiltersResponse> {
  const response = await apiClient.get<GetFiltersResponse>(
    "/territory-manager/filters",
    {
      params: {
        field: request.field,
        subCategoryQuery: request.subCategoryQuery,
        limit: request.limit,
        afterKey: request.afterKey,
      },
    }
  );
  return response.data;
}
